import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material';
import { useUserProfile } from '../hooks/useUserProfile';

interface UserProfileDisplayProps extends Omit<TypographyProps, 'children'> {
  uid: string;
}

export default function UserProfileDisplay({ uid, ...typographyProps }: UserProfileDisplayProps) {
  const { userProfile } = useUserProfile(uid);

  const displayName = userProfile?.displayName || uid;
  const email = userProfile?.email;

  if (!email || email === displayName) {
    return <Typography component="span" {...typographyProps}>{displayName}</Typography>;
  }

  return (
    <Tooltip title={email}>
      <Typography component="span" {...typographyProps}>{displayName}</Typography>
    </Tooltip>
  );
}
